"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllNonTextKeyTypes = exports.getDefinitionForKeyType = void 0;
var puppeteer_us_keyboard_layout_1 = require("./puppeteer-us-keyboard-layout");
var nonTextKeyTypes = [
    'Backspace', 'Tab', 'Clear', 'Enter', 'Pause', 'Escape', 'PageUp', 'PageDown', 'End', 'Home',
    'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Insert', 'Delete', 'Semicolon', 'Space',
    // 'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4', 'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9',
    'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12', 'Shift', 'Control', 'Alt', 'Meta'
];
var normalizeEventData = function (_a) {
    var key = _a.key, keyCode = _a.keyCode;
    return ({ key: key, keyCode: keyCode });
};
exports.getDefinitionForKeyType = function (keyType) { return normalizeEventData(puppeteer_us_keyboard_layout_1.keyDefinitions[keyType]); };
exports.getAllNonTextKeyTypes = function () { return Object.keys(puppeteer_us_keyboard_layout_1.keyDefinitions).filter(function (keyType) { return nonTextKeyTypes.includes(keyType); }); };
//# sourceMappingURL=key-types.js.map